<template>
  <iframe :srcdoc="html"></iframe>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    html: String,
  },
  setup() {
    return {}
  },
})
</script>
